import type { JobRunInput } from "./jobRun.types";

/** An input value as text, or "" when it's missing or not text. */
export const toJobRunText = (input: unknown, name: string): string => {
  const value = ((input ?? {}) as JobRunInput)[name];
  if (typeof value === "string") return value;
  if (typeof value === "number") return String(value);
  return "";
};

/** The input with `name` set to `value`, or left out when `value` is blank. */
export const toJobRunInputWith = (input: JobRunInput, name: string, value: unknown): JobRunInput => {
  const next = { ...input };
  if (value === "" || value === undefined || value === null) delete next[name];
  else next[name] = value;
  return next;
};
